import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false

export const loadedGoogleMapsAPI = new Promise((resolve, reject) => {
  window['initMap'] = resolve;
  let googleMapScript = document.createElement('script');
  googleMapScript.setAttribute(
    'src',
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyBHyZPlDJnRD9dOXcSbCm6O7sAT0ph6_pg&callback=initMap'
  );
  document.body.appendChild(googleMapScript);
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

import moment from 'moment'

Vue.filter('date', function (value) {
  if (value) {
    return moment((value)).format('DD-MM-YYYY - hh:mm A');    
  }
});
